import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import Events from 'root/helpers/events';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import { FormGTMObjectConstructor } from 'root/utils/tracking/GA4/formTracking';
import lightboxFormInit from 'root/main/components/forms/lightbox/lightboxFormInit';

function EmailOnlyFormCtl(formElem, event) {
    this.emailOnlyForm = formElem;
    this.event = event;
    this.emailOnlyFormEmailInput = this.emailOnlyForm.querySelector('input[type=email]');
}
EmailOnlyFormCtl.prototype = {
    focusFirstField(lightboxForm) {
        const firstInput = lightboxForm.querySelector(
            '[data-form=ls-form] > [data-formfield=ls-form-field] input'
        );
        if (firstInput) {
            firstInput.setAttribute('autofocus', '');
        }
    },
    populateEmailInput() {
        if (this.emailOnlyFormEmailInput.value) {
            const lightboxForm = document.querySelector('.js-lightbox-wrapper');
            if (lightboxForm) {
                const lightboxFormEmailInput =
                    lightboxForm.querySelector('input[type=email]');
                lightboxFormEmailInput.setAttribute(
                    'value',
                    this.emailOnlyFormEmailInput.value
                );
                lightboxFormEmailInput.parentElement.classList.add('js-field-valid');
                this.focusFirstField(lightboxForm);
            }
        }
        document.removeEventListener('loadLightbox', this.populateEmailInput.bind(this));
    },

    loadLightboxEventHandler() {
        this.event.addListener('lightboxOpened', this.populateEmailInput.bind(this));
    },

    openLightbox(e) {
        const submitBtn = this.emailOnlyForm.querySelector('button[type=submit]');
        const url = decodeURI(submitBtn.dataset.ctaUrl);
        if (url) {
            lightboxFormInit(e, url);
            this.loadLightboxEventHandler();
        }
    },

    submitHandler(e) {
        /* prevents the submit event reloading the page */
        e.preventDefault();
        gtm.form(this.emailOnlyForm).sendEvent('submit');
        this.openLightbox(e);
    },

    init() {
        this.emailOnlyForm.addEventListener('submit', this.submitHandler.bind(this));
    },
};

export default function (els) {
    const formEls = els;
    if (formEls.length > 0) {
        formEls.forEach(formEl => {
            if (formEl && formEl.dataset.formName.includes('email_only')) {
                /* remove the default action that submits the form to master submit /rest/forms/master-submit */
                formEl.setAttribute('action', '');
                const emailOnlyFormCtl = new EmailOnlyFormCtl(formEl, Events);
                emailOnlyFormCtl.init();
                gtm.form(formEl).sendEvent('in-page');
                const formGTMObjectConstructor = new FormGTMObjectConstructor(formEl);
                GoogleTagManager.sendEvent(
                    formGTMObjectConstructor.getFormGTMObject('form_in_page')
                );
            }
        });
    }
}
